interface Props {
	title: string
}

function Title({ title }: Props) {
	return (
		<h3 className="mt-4 text-center font-dreamAvenue text-5xl md:text-7xl">
			The{' '}
			<span className="font-monsieurLaDoulaise text-8xl text-title md:text-9xl">
				{title}
			</span>
		</h3>
	)
}

export { Title }
